import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import _findLast from 'lodash/findLast';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Custom
import { deviceCmdDataShape, asyncOperationDataShape } from 'constants/PropTypesShapes';
import { ASYNC_OP_STATUS_PENDING } from 'constants/App';
import {
  PingContainedButton, SyncContainedButton, RebootContainedButton, ResetContainedButton,
} from 'components/buttons/ContainedButtons';
import {
  PingIconButton, SyncIconButton, RebootIconButton, ResetIconButton,
} from 'components/buttons/IconButtons';

const PingContainedButtonComponent = React.memo((props) => (
  <PingContainedButton {...props} />
));
PingContainedButtonComponent.displayName = 'PingContainedButtonComponent';

const SyncContainedButtonComponent = React.memo((props) => (
  <SyncContainedButton {...props} />
));
SyncContainedButtonComponent.displayName = 'SyncContainedButtonComponent';

const RebootContainedButtonComponent = React.memo((props) => (
  <RebootContainedButton {...props} />
));
RebootContainedButtonComponent.displayName = 'RebootContainedButtonComponent';

const ResetContainedButtonComponent = React.memo((props) => (
  <ResetContainedButton context="warning" {...props} />
));
ResetContainedButtonComponent.displayName = 'ResetContainedButtonComponent';

const ButtonComponents = {
  ping: PingContainedButtonComponent,
  sync: SyncContainedButtonComponent,
  reboot: RebootContainedButtonComponent,
  reset: ResetContainedButtonComponent,
};

const PingIconButtonComponent = React.memo((props) => (
  <PingIconButton primary {...props} />
));
PingIconButtonComponent.displayName = 'PingIconButtonComponent';

const SyncIconButtonComponent = React.memo((props) => (
  <SyncIconButton primary {...props} />
));
SyncIconButtonComponent.displayName = 'SyncIconButtonComponent';

const RebootIconButtonComponent = React.memo((props) => (
  <RebootIconButton primary {...props} />
));
RebootIconButtonComponent.displayName = 'RebootIconButtonComponent';

const ResetIconButtonComponent = React.memo((props) => (
  <ResetIconButton context="warning" {...props} />
));
ResetIconButtonComponent.displayName = 'ResetIconButtonComponent';

const IconButtonComponents = {
  ping: PingIconButtonComponent,
  sync: SyncIconButtonComponent,
  reboot: RebootIconButtonComponent,
  reset: ResetIconButtonComponent,
};

const DeviceCmdTriggerItem = ({
  itemType, cmd, deviceCmd, asyncOperations, onTrigger,
}) => {
  // Try to find async operation associated (deviceCmd may be null)
  const asyncOperation = _find(asyncOperations, ['id', _get(deviceCmd, 'asyncOperationId')]);

  // Component props
  const compProps = {
    loading: _get(asyncOperation, 'status') === ASYNC_OP_STATUS_PENDING,
    onClick: onTrigger,
  };

  if (itemType === 'button') {
    const ButtonComponent = ButtonComponents[cmd];

    if (ButtonComponent) {
      return (
        <ButtonComponent {...compProps} />
      );
    }
  } else if (itemType === 'icon') {
    const ButtonComponent = IconButtonComponents[cmd];

    if (ButtonComponent) {
      return (
        <ButtonComponent {...compProps} />
      );
    }
  } else if (itemType === 'menu') {
    return null;
  }
  return null;
};

DeviceCmdTriggerItem.propTypes = {
  itemType: PropTypes.oneOf(['button', 'icon', 'menu']).isRequired,
  id: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  cmd: PropTypes.oneOf(['ping', 'sync', 'reboot', 'reset']).isRequired,
  deviceCmd: deviceCmdDataShape,
  asyncOperations: PropTypes.arrayOf(asyncOperationDataShape).isRequired,
  onTrigger: PropTypes.func.isRequired,
};

DeviceCmdTriggerItem.defaultProps = {
  deviceCmd: null,
};

const mapStateToProps = (state, ownProps) => ({
  deviceCmd: _findLast(state.deviceCmd.list, ({ device, cmd }) => (device.id === ownProps.id && cmd === ownProps.cmd)),
  asyncOperations: state.asyncOperation.list,
});

module.exports = connect(
  mapStateToProps,
  null,
)(DeviceCmdTriggerItem);



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/main/DeviceCmdTriggerItem.js